import React from 'react';

import { BlocksRenderer } from '@strapi/blocks-react-renderer';

import { TextWrapper } from './styles';
import { TextBlockProps } from './types';

// This component is a styled wrapper for the renderer of strapi Text Block
const TextBlock: React.FC<TextBlockProps> = ({
  text,
  color,
  paragraphType,
}) => {
  return (
    <TextWrapper as="div" color={color} paragraphType={paragraphType ?? 'p1'}>
      <BlocksRenderer content={text} />
    </TextWrapper>
  );
};

export default TextBlock;
